import React from "react";
import WhiteBgCard from "../WhiteBgCard";
import CustomCommonTooltip from "@/shared/components/ui/Upload/ToolTip/CustomCommonTooltip";
import { Info } from "lucide-react";

const DashboardCommonBgCard = ({
  children,
  title,
  icon,
  tooltipContent = "",
  stretch = false,
  headerAction = null,
}) => {
  return (
    <WhiteBgCard className={`w-full ${stretch ? "h-full flex flex-col" : ""}`}>
      <div className={`flex flex-col gap-2.5 ${stretch ? "flex-1" : ""}`}>
        <div className="flex items-center justify-between gap-3 w-full shrink-0">
          <div className="flex items-center gap-1.5 shrink-0">
            {icon}
            <h3 className="text-gray-800 dark:text-gray-100 text-[0.85rem] font-bold whitespace-nowrap">
              {title}
            </h3>
            {tooltipContent && (
              <CustomCommonTooltip content={tooltipContent}>
                <Info
                  size={14}
                  strokeWidth={1.5}
                  className="text-gray-400 dark:text-gray-500 cursor-pointer"
                />
              </CustomCommonTooltip>
            )}
          </div>
          {headerAction && <div className="shrink-0 ml-auto">{headerAction}</div>}
        </div>
        {stretch ? (
          <div className="flex-1 flex flex-col justify-end">
            {children}
          </div>
        ) : (
          children
        )}
      </div>
    </WhiteBgCard>
  );
};

export default DashboardCommonBgCard;
